import axios from 'axios'
import DibbleAPI from '../api'
import DibbleJS from "@/dibble";

export function getWelcomeData () {
    const dataRequest = {
        '#request': DibbleAPI.api.getWelcomePageData,
        'campaign_id': DibbleJS.getUID()
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function getDonatePageData () {
    const dataRequest = {
        "#request": DibbleAPI.api.getDonatePageData,
        "campaign_id": DibbleJS.getUID()
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function getDonationData () {
    const dataRequest = {
        "#request": DibbleAPI.api.getDonationData,
        "campaign_id": DibbleJS.getUID(),
        "is_event_page": true
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function getDonationRequestData (request_id) {
    const dataRequest = {
        "#request": DibbleAPI.api.getDonationRequestData,
        request_id
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function getThankYouPageData () {
    const dataRequest = {
        "#request": DibbleAPI.api.getThankYouPageData,
        "campaign_id": DibbleJS.getUID()
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function donateFund (data) {
    const dataRequest = {
        '#request': DibbleAPI.api.donate,
        "uid": DibbleJS.getUID(),
        "first_name": data.firstName,
        "last_name": data.lastName,
        "email": data.email,
        "phone": data.phone,
        "amount": +data.amount,
        "is_anonymous": data.isAnonymous,
        "note": data.note
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export function getWallData (uid) {
    const dataRequest = {
        '#request': DibbleAPI.api.getWallData,
        "campaign_id": uid
    }
    return axios.post(DibbleAPI.endpoint['development'], dataRequest)
}

export async function getWallAmountData (uid) {
    const dataRequest = {
        '#request': DibbleAPI.api.getWallAmountData,
        "campaign_id": uid
    }
    return await axios.post(DibbleAPI.endpoint['development'], dataRequest)
}
